import { Container, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import dokodemo_logo from '../../logo-dokodemo.png';



function App() {
  return (

    <Container className="center" maxWidth="sm" sx={{ pt: 5 }}>
      <Stack spacing={3} margin={5}>
        <img src={dokodemo_logo} alt="Logo" />
        <div>
          <h2>パスワードをリセットしました</h2>
          <div className="text-center">
            <Link to="/login">ログイン画面へ</Link>
          </div>
        </div>
      </Stack>
    </Container>
  )
}
export default App